export default __webpack_public_path__ + "static/media/badge_apple.542301f9.png";